import * as ACTION_TYPES from '../types';

let initialState = {
  contractList: [],
  contract: {}
}

export default (state = initialState, action) => {
    switch (action.type) {

      case ACTION_TYPES.GET_CONTRACTS:
        return {...state, contractList: action.data };

      case ACTION_TYPES.DELETE_CONTRACT:
        let newList = state.contractList.filter(contract => contract._id !== action.id);
        return {...state, contractList: newList };

      case ACTION_TYPES.GET_CONTRACT_BY_ID:
        return {...state, contract: action.data};

      case ACTION_TYPES.REQUEST:
        return {...state, loading: true };

      case ACTION_TYPES.DONE:
        return {...state, loading: false };

      case ACTION_TYPES.RESET_CONTRACT:
        return {...state, contractList: []};

      default:
        return state;
    }
  };